import React from 'react'
import { withRouter } from 'react-router-dom'
import * as request from 'superagent'
import { auth } from '../../firebase'
import { API_BASE_URL } from '../../index'
import { Intent } from '@blueprintjs/core'
import GoogleLogin from 'react-google-login'

import { Toast } from '../../Toaster'

import './login.css'

const login = (history, addUser) => (result) => {
  if (result.profileObj && result.profileObj.email) {
    const email = result.profileObj.email
    if (/^.*@abracontrols\.com$/.test(email)) {
      // Send result to server
      request
        .post(API_BASE_URL + '/auth')
        .send(result)
        .then(res => {
          if (res.ok) {
            const token = res.body.token
            auth.signInWithCustomToken(token)
              .then(() => {
                history.push('/dash')
              })
              .catch(err => {
                console.log(err)
              })
          } else {
            throw new Error('Network failure')
          }
        }).catch(err => {
          console.log(err)
          Toast.show({
            message: 'Oops! Something went wrong',
            iconName: 'warning-sign',
            intent: Intent.DANGER
          })
        })
    } else {
      console.log('Not abra.')
      Toast.show({
        message: 'You are not authorized to use this app',
        iconName: 'warning-sign',
        intent: Intent.DANGER
      })
    }
  } else {
    console.log('No email')
    Toast.show({
      message: 'Oops! Something went wrong',
      iconName: 'warning-sign',
      intent: Intent.DANGER
    })
  }
}

const Login = ({ history, addUser }) => (
  <div className='login-body'>
    <div className='pt-card login-form'>
      <GoogleLogin
        className='pt-button pt-large pt-fill pt-intent-primary'
        clientId='874792623951-7cs09rclmvvi9nuc6j6rsdiebfaokmo4.apps.googleusercontent.com'
        buttonText='Login'
        onSuccess={login(history, addUser)}
        onFailure={(err) => console.log('error: ' + err.details)}
      />
    </div>
  </div>
)

export default withRouter(Login)



// WEBPACK FOOTER //
// ./src/Public/Login/Login.js